export const BASE_URL = 'https://restcountries.eu';
export const API_PATH = '/rest/v2/';